import React from "react";

const UserIcon = ({
  size = 24,
  color = "white",
  className = "",
  variant = "fill",
  ...props
}) => {
  if (variant === "outline") {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M5.83301 6.66667C5.83301 4.36548 7.69849 2.5 9.99967 2.5C12.3009 2.5 14.1663 4.36548 14.1663 6.66667C14.1663 8.96785 12.3009 10.8333 9.99967 10.8333C7.69849 10.8333 5.83301 8.96785 5.83301 6.66667ZM9.99967 9.16667C11.3804 9.16667 12.4997 8.04738 12.4997 6.66667C12.4997 5.28595 11.3804 4.16667 9.99967 4.16667C8.61896 4.16667 7.49967 5.28595 7.49967 6.66667C7.49967 8.04738 8.61896 9.16667 9.99967 9.16667Z"
          fill={color}
        />
        <path
          d="M5.28563 13.6193C4.03539 14.8695 3.33301 16.5652 3.33301 18.3333H4.99967C4.99967 17.0073 5.52646 15.7355 6.46414 14.7978C7.40182 13.8601 8.67359 13.3333 9.99967 13.3333C11.3258 13.3333 12.5975 13.8601 13.5352 14.7978C14.4729 15.7355 14.9997 17.0073 14.9997 18.3333H16.6663C16.6663 16.5652 15.964 14.8695 14.7137 13.6193C13.4635 12.369 11.7678 11.6667 9.99967 11.6667C8.23156 11.6667 6.53587 12.369 5.28563 13.6193Z"
          fill={color}
        />
      </svg>
    );
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M5.83301 6.66667C5.83301 4.36548 7.69849 2.5 9.99967 2.5C12.3009 2.5 14.1663 4.36548 14.1663 6.66667C14.1663 8.96785 12.3009 10.8333 9.99967 10.8333C7.69849 10.8333 5.83301 8.96785 5.83301 6.66667ZM9.99967 9.16667C11.3804 9.16667 12.4997 8.04738 12.4997 6.66667C12.4997 5.28595 11.3804 4.16667 9.99967 4.16667C8.61896 4.16667 7.49967 5.28595 7.49967 6.66667C7.49967 8.04738 8.61896 9.16667 9.99967 9.16667Z"
        fill={color}
      />
      <path
        d="M5.28563 13.6193C4.03539 14.8695 3.33301 16.5652 3.33301 18.3333H4.99967C4.99967 17.0073 5.52646 15.7355 6.46414 14.7978C7.40182 13.8601 8.67359 13.3333 9.99967 13.3333C11.3258 13.3333 12.5975 13.8601 13.5352 14.7978C14.4729 15.7355 14.9997 17.0073 14.9997 18.3333H16.6663C16.6663 16.5652 15.964 14.8695 14.7137 13.6193C13.4635 12.369 11.7678 11.6667 9.99967 11.6667C8.23156 11.6667 6.53587 12.369 5.28563 13.6193Z"
        fill={color}
      />
    </svg>
  );
};

export default UserIcon;
